/* global Turbo */
import { Controller } from '@hotwired/stimulus';
import Swal from 'sweetalert2';

export default class extends Controller {
  static targets = [
    'editButton',
    'destroyButton',
    'newButton',
    'cancelButton',
    'submitButton',
    'moreInfo',
    'arrowSpan',
  ];

  connect() {
    this.setupConfirmMethod();
  }

  setupConfirmMethod = () => {
    Turbo.setConfirmMethod(async (message, el) => {
      const confirmButtonText = el.getAttribute('data-confirm-button-text') || 'Usuń';

      const result = await Swal.fire({
        title: message,
        icon: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText,
        confirmButtonColor: '#1E88E5',
        cancelButtonText: 'Anuluj',
        cancelButtonColor: '#F3F2FD',
      });

      if (result.isConfirmed) {
        this.editButtonTargets.forEach((element) => {
          element.setAttribute('disabled', true);
        });
        this.destroyButtonTargets.forEach((element) => {
          element.setAttribute('disabled', true);
        });
      } else {
        this.destroyButtonTargets.forEach((element) => {
          element.textContent = 'Usuń';
        });

        this.cancelButtonTargets.forEach((element) => {
          element.setAttribute('disabled', false);
          element.style.opacity = '1';
          element.style.cursor = 'pointer';
          element.style.pointerEvents = 'auto';
        });
      }

      return result.isConfirmed;
    });
  };

  edit() {
    this.editButtonTargets.forEach((element) => {
      element.setAttribute('disabled', true);
    });
    this.destroyButtonTargets.forEach((element) => {
      element.setAttribute('disabled', true);
    });
  }

  new() {
    this.editButtonTargets.forEach((element) => {
      element.setAttribute('disabled', true);
    });
    this.destroyButtonTargets.forEach((element) => {
      element.setAttribute('disabled', true);
    });
  }

  toggleMoreInfo(event) {
    if (this.moreInfoTarget.classList.contains('hide')) {
      event.target.textContent = 'Pokaż mniej';
    } else {
      event.target.textContent = 'Pokaż więcej';
    }
    this.moreInfoTarget.classList.toggle('hide');
    this.arrowSpanTarget.classList.toggle('arrow-expand');
  }

  cancel() {
    this.editButtonTargets.forEach((element) => {
      element.removeAttribute('disabled');
    });
    this.destroyButtonTargets.forEach((element) => {
      element.removeAttribute('disabled');
    });
    this.newButtonTargets.forEach((element) => {
      element.removeAttribute('disabled');
    });
    this.submitButtonTargets.forEach((element) => {
      element.setAttribute('disabled', true);
    });
  }

  submit() {
    this.cancelButtonTargets.forEach((element) => {
      element.setAttribute('disabled', true);
      element.style.opacity = '0.5';
      element.style.cursor = 'not-allowed';
      element.style.pointerEvents = 'none';
    });
  }

  destroyInit(event) {
    event.target.textContent = 'Usuwanie...';
  }

  dateChange(event) {
    const that = $(event.target);
    const currentValue = that.val();
    const timestamp = Date.parse(currentValue);
    const date = new Date(timestamp).toJSON();
    const alloweEmpty = that.data('allow-empty');

    event.preventDefault();

    if (alloweEmpty && currentValue === '') {
      return;
    }

    if (Number.isNaN(timestamp) || timestamp === '' || timestamp === null || date.slice(0, 10) !== currentValue) {
      that.datepicker().datepicker('setDate', new Date());
      that.trigger('blur');

      toastr.warning('Wybrana data była nieprawidłowa i została automatycznie poprawiona.');
    }
  }
}
